import { render } from "./NewAdvisorFormComponent.vue?vue&type=template&id=3b36b89a&scoped=true"
import script from "./NewAdvisorFormComponent.vue?vue&type=script&lang=js"
export * from "./NewAdvisorFormComponent.vue?vue&type=script&lang=js"

import "./NewAdvisorFormComponent.vue?vue&type=style&index=0&id=3b36b89a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b36b89a"]])

export default __exports__